import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { MouseEvents } from "../../../componets3D/MouseEvents";
import { CameraController } from "../../../componets3D/CameraController";
import { Floor } from "../../objects/Floor";
// import { DragControls } from "three/addons/controls/DragControls.js";
import { MapSubtopicTwo } from "../../objects/Tema1/subtopicTwo/MapSubtopicTwo";
import { DirtyGondolas } from "../../objects/Tema1/subtopicTwo/DirtyGondolas";
import ObserverEmitter, { EVENTS } from "../../../../emitter/Observer";
import { CharcterOxxo } from "../../objects/CharacterOxxo";
import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { TrayProduct } from "../../objects/Tema1/subtopicTwo/TrayProduct";
import { audiosAssets } from "../../../../assets/audio";
import { Gondola } from "../../objects/Tema1/subtopicTwo/Gondola";

// const _PI_2 = Math.PI / 2;
// const _euler = new Euler(0, 0, 0, "YXZ");
export class SceneTopicTwo extends Scene {
	constructor(loadingManager, container, render, characterSelected = new CharcterOxxo(), enviroment) {
		super();
		this.environment = enviroment;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.characterSelected = characterSelected;
		this.renderer = render;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.pointsActivityTwo = 0;
		this.pointsActivityTwoFondeo = 0;
		this.create();
		this.light();
		// this.helper();
		this.observerListeners();
		this.renderAnimations();
	}
	create() {
		this.add(this.characterSelected);

		this.oxxo = new MapSubtopicTwo(this.loadingManager);
		this.add(this.oxxo);

		this.dirtyGondolas = new DirtyGondolas(this.loadingManager);
		this.dirtyGondolas.visible = false;
		this.add(this.dirtyGondolas);

		this.floor = new Floor(this.loadingManager);
		this.add(this.floor);

		this.trayProduct = new TrayProduct(this.loadingManager);

		this.gondolaAct2 = new Gondola(this.loadingManager);
		this.gondolaAct2.visible = false;
		this.add(this.gondolaAct2);
	}

	SceneInitialState() {
		this.mouseEvents.disposeInteractions();
	}
	sceneactivityOneSctate() {
		this.gondolaAct2.visible = false;
		this.dirtyGondolas.visible = true;
		this.characterSelected.onAnimateIdle();
		this.characterSelected.visible = true;
		this.oxxo.onHiddenGondolasActivityOne();
		// this.mouseEvents.objectsToValue = [this.floor, this.dirtyGondolas];
		this.mouseEvents.objectsToValue = [this.dirtyGondolas];

		this.camera.enabledOrbitControls();
		// this.camera.disabledOrbitControls();

		this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
		this.characterSelected.rotation.set(0, -1.5145, 0);

		this.dirtyGondolas.clearAnimation()
		setTimeout(() => {
			this.dirtyGondolas.onAnimateAll();
		}, 2000);
	}

	sceneActivityTwoState() {
		this.gondolaAct2.positionInitAll()

		this.gondolaAct2.onStatusActivityTwo()
		this.gondolaAct2.visible = true;
		// this.oxxo.onStatusActivityTwo();
		this.dirtyGondolas.visible = false;

		this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
		this.characterSelected.rotation.set(0, -1.5145, 0);
		this.characterSelected.onAnimateSaludo();
		this.characterSelected.visible = true

		this.oxxo.positionBoxSet()
		this.pointsActivityTwo = 0;
		this.pointsActivityTwoFondeo = 0;


		this.oxxo.onShowGondolasDefault();
		this.oxxo.onHiddenActTwo()

		this.camera.enabledOrbitControls();

		this.mouseEvents.disposeInteractions();
		this.mouseEvents.objectsToValue = [
			this.oxxo.Box_1,
			this.oxxo.Box_2,
			this.oxxo.Box_3,
			this.oxxo.Box_4,

			this.gondolaAct2.Jugo_12,
			this.gondolaAct2.Jugo_43,
			this.gondolaAct2.Suero_1,
			this.gondolaAct2.cafe_2,

			// this.oxxo.Jugo_12,
			// this.oxxo.Jugo_43,
			// this.oxxo.Suero_1,
			// this.oxxo.cafe_2,
		];
		this.mouseListenersEnableMovementActivityTwo();


		this.trayProduct.position.set(0.4704, -1.294, 3.1171);
		this.trayProduct.rotation.set(0.5587, 0, 0);
		this.add(this.trayProduct);

		ObserverEmitter.on(EVENTS.subtopicTwo.activityTwo.initFondeo, () => {
			this.characterSelected.visible = false;
			this.camera.control.maxPolarAngle = MathUtils.degToRad(75);
			this.camera.control.minPolarAngle = MathUtils.degToRad(55);
			this.camera.moveCameraToPoint(new Vector3(0.4055, 0.9182, 4.4389), 1, new Vector3(0.348, -1.122, -0.503), () => {
				this.gondolaAct2.statusActvTwoFondeo();
				// this.oxxo.statusActvTwoFondeo();
				this.mouseEvents.defaultInteractions();
				this.mouseEvents.objectsToValue = [
					this.oxxo.Box_1fondeo,
					this.oxxo.Box_2fondeo,
					this.oxxo.Box_3fondeo,
					this.oxxo.Box_4fondeo,

					this.gondolaAct2.Refresco_22001,
					this.gondolaAct2.Gatorade_1001,
					this.gondolaAct2.Jugo_36001,
					this.gondolaAct2.Jugo_23001,

					// this.oxxo.Refresco_22001,
					// this.oxxo.Gatorade_1001,
					// this.oxxo.Jugo_36001,
					// this.oxxo.Jugo_23001,

				];
				this.mouseListenersActivityTwoFondeo();

				this.characterSelected.visible = false;

				this.trayProduct.position.set(0.4704, -0.2577, 2.7847);
			});
		});
	}

	observerListeners() {
		ObserverEmitter.on(EVENTS.subtopicTwo.activityone.initInteractions, () => {
			this.camera.moveCameraToPoint(new Vector3(-2.0628, -0.4993, -0.0154), 1, new Vector3(-1.674, -0.747, -0.209), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = Infinity;
				this.camera.control.minDistance = 0.2;
				this.camera.control.maxDistance = 1;
				this.camera.control.enableZoom = true;
				this.camera.control.enablePan = false;

				this.mouseListenersEnableMovementActivityone();
			});
		});

		ObserverEmitter.on(EVENTS.subtopicTwo.activityone.moveCamareGameOne, () => {
			this.camera.moveCameraToPoint(new Vector3(0.5115, -0.0821, 5.111), 1, new Vector3(0.483, -1.088, -0.14), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(70);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = 0.267;
				this.camera.control.minAzimuthAngle = -0.274;
				this.camera.control.minDistance = 0.1;
				this.camera.control.maxDistance = 10;
				this.camera.control.enableZoom = false;
				this.camera.control.enablePan = false;
			});
		});

		ObserverEmitter.on(EVENTS.subtopicTwo.activityTwo.moveCamareTable, () => {
			this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = Infinity;
				this.camera.control.minDistance = 0.1;
				this.camera.control.maxDistance = 10;
				this.camera.control.enableZoom = false;
				this.camera.control.enablePan = false;

				this.characterSelected.visible = true;
				this.characterSelected.onAnimateSaludo();
			});
		});
	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-12.6836, -0.0611, -2.7612), 1, new Vector3(-10.005, -0.371, -1.869), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(90);
					this.camera.control.minPolarAngle = MathUtils.degToRad(70);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;
					this.activeAudio()
				});
				break;
			case 1:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.sceneactivityOneSctate();
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 0.1;
					this.camera.control.maxDistance = 10;
					this.camera.control.enableZoom = false;
					this.camera.control.enablePan = false;
					this.activeAudio()
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.sceneActivityTwoState();
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 0.1;
					this.camera.control.maxDistance = 10;
					this.camera.control.enableZoom = false;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.activeAudio()
				});
				break;
			case 3:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
					this.characterSelected.rotation.set(0, -1.5145, 0);
					this.activeAudio()
				});
				break;

			default:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = false;
					this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
					this.characterSelected.rotation.set(0, -1.5145, 0);
					this.activeAudio()
				});
				break;
		}
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	disposeMeshinScene(uuid) {
		// TODO: optimizate to hidden models
		const object = this.getObjectByProperty("uuid", uuid);
		object.visible = false;
		object.position.y += 100;
		ObserverEmitter.emit(EVENTS.subtopicTwo.activityone.findProduct);
		// this.renderer.renderLists.dispose();
	}

	detectSelecteddityObejct(objectcliked) {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoLimpia)
		switch (objectcliked.name) {
			case "Cereal_1002":
				this.dirtyGondolas.animationCereal_1002.kill();
				this.disposeMeshinScene(objectcliked.uuid);
				return true;
			case "Cereal_2002":
				this.dirtyGondolas.animationCereal_2002.kill();
				this.disposeMeshinScene(objectcliked.uuid);
				return true;
			case "Cereal_3002":
				this.dirtyGondolas.animationCereal_3002.kill();
				this.disposeMeshinScene(objectcliked.uuid);
				return true;
			case "Cereal_4002":
				this.dirtyGondolas.animationCereal_4002.kill();
				this.disposeMeshinScene(objectcliked.uuid);
				return true;
			case "Cereal_5002":
				this.dirtyGondolas.animationCereal_5002.kill();
				this.disposeMeshinScene(objectcliked.uuid);
				return true;
			case "Cereal_6002":
				this.dirtyGondolas.animationCereal_6002.kill();
				this.disposeMeshinScene(objectcliked.uuid);
				return true;
			case "Cereal_7002":
				this.dirtyGondolas.animationCereal_7002.kill();
				this.disposeMeshinScene(objectcliked.uuid);
				return true;
			case "Cereal_8002":
				this.dirtyGondolas.animationCereal_8002.kill();
				this.disposeMeshinScene(objectcliked.uuid);
				return true;
			case "Latas_1001":
				this.dirtyGondolas.animationLatas_1001.kill();
				this.disposeMeshinScene(objectcliked.uuid);
				return true;
			case "Latas_2001":
				this.dirtyGondolas.animationLatas_2001.kill();
				this.disposeMeshinScene(objectcliked.uuid);
				return true;
			case "Latas_3001":
				this.dirtyGondolas.animationLatas_3001.kill();
				this.disposeMeshinScene(objectcliked.uuid);
				return true;
			case "Manchas_1":
				this.dirtyGondolas.animationManchas_1.kill();
				this.disposeMeshinScene(objectcliked.uuid);
				return true;
			case "Manchas_2":
				this.dirtyGondolas.animationManchas_2.kill();
				this.disposeMeshinScene(objectcliked.uuid);
				return true;
			default:
				return false;
		}
	}

	mouseListenersEnableMovementActivityone() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				this.detectSelecteddityObejct(interactions[0].object);

				// console.log(interactions[0].object);
				// if (interactions[0].object.name === "Piso") {
				// 	this.camera.moveCameraToPoint(
				// 		new Vector3(interactions[0].point.x, 0.0394, interactions[0].point.z),
				// 		1,
				// 		new Vector3(interactions[0].point.x - 0.1, -0.272, interactions[0].point.z - 0.1),
				// 		() => { }
				// 	);
				// } else {
				// 	this.detectSelecteddityObejct(interactions[0].object);
				// }
			}
		});
		// this.mouseEvents.onPointerDrag((e) => {
		// 	const movementX = e.movementX || e.mozMovementX || e.webkitMovementX || 0;
		// 	const movementY = e.movementY || e.mozMovementY || e.webkitMovementY || 0;

		// 	_euler.setFromQuaternion(this.camera.quaternion);
		// 	_euler.y -= movementX * 0.002 * 1.0;
		// 	_euler.x -= movementY * 0.002 * 1.0;
		// 	_euler.x = Math.max(_PI_2 - Math.PI, Math.min(_PI_2 - 0, _euler.x));
		// 	this.camera.quaternion.setFromEuler(_euler);
		// });
	}

	animateProductToMove(selected, positionsend) {
		const timeline = gsap.timeline();

		timeline.to(selected.position, {
			duration: 0.5,
			x: positionsend.x,
			y: positionsend.y,
			z: positionsend.z,
			onComplete: () => { },
		});
		timeline.play();
	}

	evaluateActvTwo(selected, place) {
		this.oxxo.onAnimate()
		if (selected.name === "Jugo_43" && place.name === "Box-1") {
			place.position.y = 5000;
			this.pointsActivityTwo++;
			this.animateProductToMove(selected, { x: 21.528, y: 120.181, z: selected.position.z });
		} else if (selected.name === "Jugo_26" && place.name === "Box-2") {
			place.position.y = 5000;
			this.pointsActivityTwo++;
			this.animateProductToMove(selected, { x: -9.707, y: 121.738, z: 20.358 });
		} else if (selected.name === "cafe_2" && place.name === "Box-3") {
			place.position.y = 5000;
			this.pointsActivityTwo++;
			this.animateProductToMove(selected, { x: -30.386, y: 120.553, z: selected.position.z });
		} else if (selected.name === "Suero_1" && place.name === "Box-4") {
			place.position.y = 5000;
			this.pointsActivityTwo++;
			this.animateProductToMove(selected, { x: 61.181, y: 120.553, z: selected.position.z });
		} else {
			const timeline = gsap.timeline();

			timeline.to(selected.position, {
				duration: 0.15,
				x: selected.position.x + 10,
				y: selected.position.y,
				z: selected.position.z,
				onComplete: () => { },
				ease: CustomEase.create("custom", "M0,0 C0.126,0.382 0.201,1.167 0.262,0.96 0.87,-1.12 0.614,2.65 1,0.01 "),
			});
			timeline.play();
		}
		if (this.pointsActivityTwo === 4) {
			ObserverEmitter.emit(EVENTS.subtopicTwo.activityTwo.completeFrenteo);
			this.characterSelected.visible = true;
			this.characterSelected.onAnimationFestejo();
		}
	}

	mouseListenersEnableMovementActivityTwo() {
		let productcliked;
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				if (productcliked && interactions[0].object.name.includes("Box")) {
					ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoLugar)
					this.oxxo.onVisibleCubesActvTwo(false);
					this.evaluateActvTwo(productcliked, interactions[0].object);
				} else {
					ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoObjeto)
					this.oxxo.onVisibleCubesActvTwo(true);
					productcliked = interactions[0].object;
					this.oxxo.onAnimate(productcliked)
				}
			}
		});
	}

	// Activity Two part2 Fondeo

	onamimateFondeo(selected, others, selectedPosition, otherPosition) {
		const timeline = gsap.timeline();

		timeline.to(selected.position, {
			duration: 0.4,
			x: selectedPosition.x,
			y: selectedPosition.y,
			z: selectedPosition.z,
			onComplete: () => {
				timeline.to(others.position, {
					duration: 0.6,
					x: otherPosition.x,
					y: otherPosition.y,
					z: otherPosition.z,
				});
				timeline.to(
					selected.position,
					{
						duration: 0.6,
						x: selectedPosition.x,
						y: selectedPosition.y,
						z: otherPosition.z,
					},
					`-=${0.6}`
				);
			},
		});
		timeline.play();
	}

	// evaluateActvTwoFondeo(selected, place) {
	// 	this.oxxo.onAnimate()
	// 	if (selected.name === "Refresco_22001" && place.name === "Box-1fondeo") {
	// 		place.position.y = 5000;
	// 		this.pointsActivityTwoFondeo++;
	// 		// this.animateProductToMove(selected, { x: 21.528, y: 120.181, z: selected.position.z });
	// 		this.onamimateFondeo(selected, this.oxxo.Refresco_22, { x: -29.442, y: 85.879, z: -31.821 }, { x: -29.442, y: 110.672, z: -11.147 });
	// 	} else if (selected.name === "Gatorade_1001" && place.name === "Box-2fondeo") {
	// 		place.position.y = 5000;
	// 		this.pointsActivityTwoFondeo++;
	// 		this.onamimateFondeo(selected, this.oxxo.Gatorade_1, { x: 4.26, y: 85.769, z: -34.843 }, { x: 4.26, y: 112.555, z: -13.438 });
	// 	} else if (selected.name === "Jugo_36001" && place.name === "Box-3fondeo") {
	// 		place.position.y = 5000;
	// 		this.pointsActivityTwoFondeo++;
	// 		this.onamimateFondeo(selected, this.oxxo.Jugo_36, { x: 27.905, y: 88.273, z: -33.135 }, { x: 27.905, y: 112.555, z: -12.59 });
	// 	} else if (selected.name === "Jugo_23001" && place.name === "Box-4fondeo") {
	// 		place.position.y = 5000;
	// 		this.pointsActivityTwoFondeo++;
	// 		this.onamimateFondeo(selected, this.oxxo.Jugo_23, { x: 81.725, y: 88.67, z: -33.135 }, { x: 81.725, y: 114.907, z: -12.891 });
	// 	} else {
	// 		const timeline = gsap.timeline();

	// 		timeline.to(selected.position, {
	// 			duration: 0.15,
	// 			x: selected.position.x + 10,
	// 			y: selected.position.y,
	// 			z: selected.position.z,
	// 			onComplete: () => { },
	// 			ease: CustomEase.create("custom", "M0,0 C0.126,0.382 0.201,1.167 0.262,0.96 0.87,-1.12 0.614,2.65 1,0.01 "),
	// 		});
	// 		timeline.play();
	// 	}
	// 	if (this.pointsActivityTwoFondeo === 4) {
	// 		this.characterSelected.visible = true;
	// 		this.characterSelected.onAnimationFestejo();
	// 		ObserverEmitter.emit(EVENTS.subtopicTwo.activityTwo.completeFondeo);
	// 	}
	// }

	evaluateActvTwoFondeoGondola(selected, place) {
		this.gondolaAct2.onAnimate()
		if (selected.name === "Refresco_22001" && place.name === "Box-1fondeo") {
			place.position.y = 5000;
			this.pointsActivityTwoFondeo++;
			// this.animateProductToMove(selected, { x: 21.528, y: 120.181, z: selected.position.z });
			this.onamimateFondeo(selected, this.gondolaAct2.Refresco_22, { x: -29.442, y: 85.879, z: -31.821 }, { x: -29.442, y: 110.672, z: -11.147 });
		} else if (selected.name === "Gatorade_1001" && place.name === "Box-2fondeo") {
			place.position.y = 5000;
			this.pointsActivityTwoFondeo++;
			this.onamimateFondeo(selected, this.gondolaAct2.Gatorade_1, { x: 4.26, y: 85.769, z: -34.843 }, { x: 4.26, y: 112.555, z: -13.438 });
		} else if (selected.name === "Jugo_36001" && place.name === "Box-3fondeo") {
			place.position.y = 5000;
			this.pointsActivityTwoFondeo++;
			this.onamimateFondeo(selected, this.gondolaAct2.Jugo_36, { x: 27.905, y: 88.273, z: -33.135 }, { x: 27.905, y: 112.555, z: -12.59 });
		} else if (selected.name === "Jugo_23001" && place.name === "Box-4fondeo") {
			place.position.y = 5000;
			this.pointsActivityTwoFondeo++;
			this.onamimateFondeo(selected, this.gondolaAct2.Jugo_23, { x: 81.725, y: 88.67, z: -33.135 }, { x: 81.725, y: 114.907, z: -12.891 });
		} else {
			const timeline = gsap.timeline();

			timeline.to(selected.position, {
				duration: 0.15,
				x: selected.position.x + 10,
				y: selected.position.y,
				z: selected.position.z,
				onComplete: () => { },
				ease: CustomEase.create("custom", "M0,0 C0.126,0.382 0.201,1.167 0.262,0.96 0.87,-1.12 0.614,2.65 1,0.01 "),
			});
			timeline.play();
		}
		if (this.pointsActivityTwoFondeo === 4) {
			this.characterSelected.visible = true;
			this.characterSelected.onAnimationFestejo();
			ObserverEmitter.emit(EVENTS.subtopicTwo.activityTwo.completeFondeo);
		}
	}

	mouseListenersActivityTwoFondeo() {
		let productcliked;
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				if (productcliked && interactions[0].object.name.includes("Box")) {
					ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoLugar)
					this.oxxo.onVisibleCubesActvTwoFondeo(false);
					this.evaluateActvTwoFondeoGondola(productcliked, interactions[0].object);
				} else {
					ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoObjeto)
					this.oxxo.onVisibleCubesActvTwoFondeo(true);
					productcliked = interactions[0].object;
					this.oxxo.onAnimate(productcliked)
				}
			}
		});
	}
	//

	renderAnimations(delta) { }
}
